import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Organization } from '../../types/organization.types';
import { updateOrganization } from '../../api/remiApi';

export const useSMSSettings = () => {
  const queryClient = useQueryClient();

  const updateSMSSettings = async (orgId: string, data: Partial<Organization>) => {
    await updateOrganization(orgId, data as Record<string, unknown>);
  };

  const { mutateAsync: updateSettings, isPending } = useMutation({
    mutationFn: ({ orgId, data }: { orgId: string; data: Partial<Organization> }) =>
      updateSMSSettings(orgId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['Organizations'] });
    },
  });

  return {
    updateSettings,
    isPending,
  };
};
